import Vue  from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/assets/lan/en.js'

Vue.use(VueI18n);
// Create VueI18n instance with options
export const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || process.env.KIPAKI_locale, // set locale
    fallbackLocale: 'en',
    messages, // set locale messages
})


// WEBPACK FOOTER //
// ./src/plugins/i18n.js